function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Droppable } from "react-beautiful-dnd";
import { ItemType } from "sprout-graphql";
import { useNavigationList } from "@sprout/list-navigation";
import DragDropContextCustomSensors from "@sprout/client-components/dist/DragDropContextCustomSensors";
import { Box } from "sprout-ui-primitives";
import PostPageTodoListNewEditor from "../PostPageTodoList/PostPageTodoListNewEditor";
import useSortTodosAndTodoLists from "../graphql/mutations/useSortTodosAndTodoLists";
import useTodoListSingularAction from "../PostPageTodoList/useTodoListSingularAction";
import PostPageDividerText from "../PostPageDividerText";
import PostPageTodosTodoLists from "./PostPageTodosTodoLists";
import PostPageTodosOrphanTodos from "./PostPageTodosOrphanTodos";
const PostPageTodosMain = (props)=>{
    const { todos , todoLists , disabled , postId , postNodeId , wrapperComponent , todoSingularAction , todoSupportedActions ,  } = props;
    const { todoListSupportedActions , todoListSingularAction  } = useTodoListSingularAction({
        postNodeId,
        disabled
    });
    const { Provider , navProps  } = useNavigationList("PostPageTodosSection", useMemo(()=>({
            groupContainer: true,
            actions: todoListSupportedActions,
            performSingularAction: todoListSingularAction
        }), [
        todoListSingularAction,
        todoListSupportedActions
    ]));
    const Wrapper = wrapperComponent || Box;
    const onDragEnd = useSortTodosAndTodoLists();
    return /*#__PURE__*/ _jsxs(Provider, {
        children: [
            (todos.length > 0 || todoLists.length > 0) && /*#__PURE__*/ _jsx(PostPageDividerText, {
                text: "Leaves"
            }),
            /*#__PURE__*/ _jsx(Wrapper, _objectSpread({}, navProps, {
                children: /*#__PURE__*/ _jsxs(DragDropContextCustomSensors, {
                    onDragEnd: onDragEnd,
                    children: [
                        /*#__PURE__*/ _jsx(PostPageTodosOrphanTodos, {
                            todos: todos,
                            disabled: disabled,
                            postId: postId,
                            postNodeId: postNodeId,
                            todoSingularAction: todoSingularAction,
                            todoSupportedActions: todoSupportedActions
                        }),
                        /*#__PURE__*/ _jsx(PostPageTodoListNewEditor, {
                            postId: postId,
                            postNodeId: postNodeId
                        }),
                        /*#__PURE__*/ _jsx(Droppable, {
                            droppableId: JSON.stringify({
                                id: postId,
                                nodeId: postNodeId
                            }),
                            type: ItemType.Checklist,
                            isDropDisabled: disabled,
                            children: (dropProvided)=>{
                                return(// eslint-disable-next-line @typescript-eslint/unbound-method
                                /*#__PURE__*/ _jsxs("div", {
                                    ref: dropProvided.innerRef,
                                    children: [
                                        /*#__PURE__*/ _jsx(PostPageTodosTodoLists, {
                                            disabled: disabled,
                                            todoLists: todoLists,
                                            todoSingularAction: todoSingularAction,
                                            todoSupportedActions: todoSupportedActions
                                        }),
                                        dropProvided.placeholder
                                    ]
                                }));
                            }
                        })
                    ]
                })
            }))
        ]
    });
};
export default PostPageTodosMain;
